import {Button, Stack, Typography} from '@mui/material';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {EmptyAlertProps} from './types';

const {emptyAlert} = translations['pt-br'].privateFlow.profile.changeData;
const EmptyAlert = ({type, onClick, hideAction, inlineStyle, icon, dataTagId}: EmptyAlertProps) => (
	<Stack
		mt={hideAction ? 2 : 0}
		flexDirection={inlineStyle ? 'row' : 'column'}
		justifyContent={inlineStyle ? 'space-between' : 'start'}
		alignItems={inlineStyle ? 'center' : 'initial'}>
		{icon}
		<Typography variant="body1" color="text.secondary">
			{emptyAlert[type]}
		</Typography>

		{!hideAction ? (
			<Stack direction="row" justifyContent="flex-end">
				<Button variant="text" onClick={onClick} data-tag-id={dataTagId}>
					{emptyAlert.action[type]}
				</Button>
			</Stack>
		) : null}
	</Stack>
);

export {EmptyAlert};
